/* Yikeyo live tier, shipping and complementary add-on logic */
(function () {
  if (window.__yikeyoCartGrowthV1) {
    window.__yikeyoCartGrowthV1.refresh();
    return;
  }

  var FREE_SHIPPING_CENTS = 2500;
  var timer;

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function discountRate(count) {
    if (count >= 4) return .30;
    if (count === 3) return .20;
    if (count === 2) return .10;
    return 0;
  }

  function nextRate(count) {
    if (count <= 1) return .10;
    if (count === 2) return .20;
    if (count === 3) return .30;
    return .30;
  }

  function inferCategory(text) {
    text = (text || '').toLowerCase();
    if (text.indexOf('recovery') > -1 || text.indexOf('surgery') > -1 || text.indexOf('anti-lick') > -1) return 'recovery';
    if (text.indexOf('dress') > -1 || text.indexOf('tutu') > -1) return 'dress';
    if (text.indexOf('pajama') > -1 || text.indexOf('pj') > -1 || text.indexOf('onesie') > -1) return 'pajamas';
    if (text.indexOf('sweater') > -1 || text.indexOf('fleece') > -1 || text.indexOf('hoodie') > -1) return 'sweater';
    if (text.indexOf('tee') > -1 || text.indexOf('tank') > -1) return 'tee';
    if (text.indexOf('shirt') > -1) return 'shirt';
    return 'other';
  }

  function inferSeason(text) {
    text = (text || '').toLowerCase();
    if (text.indexOf('fleece') > -1 || text.indexOf('sweater') > -1 || text.indexOf('winter') > -1 || text.indexOf('flannel') > -1) return 'winter';
    if (text.indexOf('summer') > -1 || text.indexOf('tutu') > -1 || text.indexOf('dress') > -1 || text.indexOf('tee') > -1 || text.indexOf('tank') > -1 || text.indexOf('hawaiian') > -1 || text.indexOf('quick-dry') > -1) return 'summer';
    return 'all';
  }

  function itemText(item) {
    return [item.title, item.product_title, item.handle, item.url].filter(Boolean).join(' ');
  }

  function grossSubtotal(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      var unit = typeof item.original_price === 'number' ? item.original_price : item.price;
      return sum + unit * item.quantity;
    }, 0);
  }

  function render(cart) {
    var count = cart.item_count || 0;
    var gross = grossSubtotal(cart);
    var currentRate = discountRate(count);
    var targetRate = nextRate(count);
    var postDiscount = Math.round(gross * (1 - currentRate));
    var currentSavings = gross - postDiscount;
    var targetSavings = Math.round(gross * targetRate);
    var currency = cart.currency || 'USD';
    var inCart = {};
    var cartCategories = {};
    var cartSeasons = {};

    (cart.items || []).forEach(function (item) {
      var txt = itemText(item);
      inCart[String(item.product_id)] = true;
      if (item.handle) inCart[item.handle] = true;
      cartCategories[inferCategory(txt)] = true;
      cartSeasons[inferSeason(txt)] = true;
    });

    var cartHasRecovery = !!cartCategories.recovery;

    document.querySelectorAll('[data-ykeyo-cart-growth]').forEach(function (module) {
      var message = module.querySelector('[data-yk-tier-message]');
      if (count <= 1) {
        var minimumSaving = Math.round(gross * .10);
        message.innerHTML = 'Add 1 more item and save <strong>10% · at least ' + money(minimumSaving, currency) + '</strong>';
      } else if (count === 2) {
        message.innerHTML = 'Add 1 more and save <strong>20% · that\'s ' + money(targetSavings, currency) + ' off</strong>';
      } else if (count === 3) {
        message.innerHTML = 'Add 1 more and save <strong>30% · that\'s ' + money(targetSavings, currency) + ' off</strong>';
      } else {
        message.innerHTML = 'Maximum savings applied · <strong>30% off · ' + money(currentSavings, currency) + ' saved</strong>';
      }

      var reached = Math.max(1, Math.min(count, 4));
      var steps = Array.prototype.slice.call(module.querySelectorAll('[data-yk-step]'));
      steps.forEach(function (step, index) {
        var n = index + 1;
        step.classList.toggle('is-reached', n <= reached);
        step.classList.toggle('is-current', n === reached);
      });
      Array.prototype.slice.call(module.querySelectorAll('.yk-cart-growth__steps i')).forEach(function (line, index) {
        line.classList.toggle('is-reached', index + 2 <= reached);
      });

      var gap = Math.max(0, FREE_SHIPPING_CENTS - postDiscount);
      var progress = Math.max(0, Math.min(100, postDiscount / FREE_SHIPPING_CENTS * 100));
      var shipMessage = module.querySelector('[data-yk-shipping-message]');
      var shipValue = module.querySelector('[data-yk-shipping-value]');
      var bar = module.querySelector('[data-yk-shipping-bar]');
      var barWrap = module.querySelector('.yk-cart-growth__bar');

      if (gap > 0) {
        shipMessage.textContent = 'You\'re ' + money(gap, currency) + ' away from free shipping';
        shipValue.textContent = money(postDiscount, currency) + ' / ' + money(FREE_SHIPPING_CENTS, currency);
      } else {
        shipMessage.textContent = 'Free shipping unlocked';
        shipValue.textContent = '✓';
      }
      bar.style.width = progress + '%';
      barWrap.setAttribute('aria-valuenow', String(Math.min(25, postDiscount / 100).toFixed(2)));

      var primarySeason = cartSeasons.winter ? 'winter' : (cartSeasons.summer ? 'summer' : 'all');
      var cards = Array.prototype.slice.call(module.querySelectorAll('[data-yk-suggestion]'));
      var suggestionTitle = module.querySelector('[data-yk-suggestion-title]');
      var suggestionNote = module.querySelector('[data-yk-suggestion-note]');

      if (suggestionTitle) suggestionTitle.textContent = cartHasRecovery ? 'Add a second suit for wash day' : 'Complete their little wardrobe';
      if (suggestionNote) suggestionNote.textContent = cartHasRecovery ? 'Recovery suits + soft pajamas' : 'Easy add-ons';
      cards.forEach(function (card) { card.hidden = true; });

      cards
        .filter(function (card) {
          var id = card.getAttribute('data-product-id');
          var handle = card.getAttribute('data-handle') || '';
          var category = card.getAttribute('data-category');
          var isRecovery = category === 'recovery' || handle.indexOf('recovery') > -1 || handle.indexOf('surgery') > -1;
          var alreadyInCart = !!inCart[id] || !!inCart[handle];

          if (cartHasRecovery) {
            if (isRecovery) return true;
            return !alreadyInCart && category === 'pajamas';
          }

          return !alreadyInCart && !isRecovery;
        })
        .sort(function (a, b) {
          function score(card) {
            var value = 0;
            var season = card.getAttribute('data-season');
            var category = card.getAttribute('data-category');
            if (cartHasRecovery && category === 'recovery') value += 20;
            if (cartHasRecovery && category === 'pajamas') value += 15;
            if (season === primarySeason || season === 'all') value += 4;
            if (!cartCategories[category]) value += 3;
            return value;
          }
          return score(b) - score(a);
        })
        .slice(0, window.matchMedia('(max-width: 599px)').matches ? 2 : 3)
        .forEach(function (card) { card.hidden = false; });
    });
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function (response) { return response.json(); })
        .then(render)
        .catch(function () {});
    }, 80);
  }

  function addItem(button) {
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (section) { return section.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
    var payload = {
      items: [{ id: Number(button.getAttribute('data-variant-id')), quantity: 1 }],
      sections: sections,
      sections_url: window.location.pathname
    };

    button.disabled = true;
    button.textContent = 'Adding…';

    fetch((window.routes && routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || 'Could not add this item.'); });
        return response.json();
      })
      .then(function (data) {
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
          window.setTimeout(function () {
            if (typeof drawer.open === 'function') drawer.open();
            refresh();
          }, 120);
        } else {
          refresh();
        }
      })
      .catch(function (error) {
        var module = button.closest('[data-ykeyo-cart-growth]');
        var target = module && module.querySelector('[data-yk-error]');
        if (target) {
          target.textContent = error.message || 'Could not add this item. Please try again.';
          target.hidden = false;
        }
        button.disabled = false;
        button.textContent = 'Add';
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-yk-add]');
    if (!button) return;
    event.preventDefault();
    addItem(button);
  });

  document.addEventListener('change', function (event) {
    if (event.target.closest('#CartDrawer')) window.setTimeout(refresh, 350);
  });
  document.addEventListener('cart:updated', refresh);
  document.addEventListener('cartUpdate', refresh);

  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) {
      return mutation.target && (mutation.target.id === 'CartDrawer' || (mutation.target.closest && mutation.target.closest('#CartDrawer')));
    })) refresh();
  });

  function start() {
    var cartDrawer = document.querySelector('#CartDrawer');
    if (cartDrawer) observer.observe(cartDrawer, { childList: true, subtree: true });
    refresh();
  }

  window.__yikeyoCartGrowthV1 = { refresh: refresh, render: render };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

 (function () {  
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return
  
      let timer 
       
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))
 
            insertSectionCartDrawer()
        }, 250)
      })

      observer.observe(element, {  
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          const respoonse = await fetch(window.location.href)
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
  })();